import { Heading, Paragraph, Stack, Tag } from '@99designs/emu';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { Price } from '@99designs/spa-common';
import type { Price as PriceType, ProductGroupType } from '../../types';

type Props = {
    title: string;
    price: PriceType;
    subtitle: string;
    description: string;
    type?: ProductGroupType;
};

export function ProductGroupSummary({ title, price, subtitle, description, type }: Props) {
    return (
        <Stack space="1.5bu">
            <Heading appearanceLevel={3} accessibilityLevel={1}>
                {title}
            </Heading>
            <Heading appearanceLevel={5} accessibilityLevel={2} as="p">
                {type && type === 'PRODUCT_GROUP_FIXED_PRICE' ? (
                    <Price amount={price.amountInCents} currency={price.currency} />
                ) : (
                    <FormattedMessage
                        message={__('Starting from {price}')}
                        values={{
                            price: <Price amount={price.amountInCents} currency={price.currency} />,
                        }}
                    />
                )}
            </Heading>
            {type && type === 'PRODUCT_GROUP_FIXED_PRICE' && (
                <Tag appearance="filled">{__('Fixed price package')}</Tag>
            )}
            <Stack space="0.75bu">
                <Heading appearanceLevel={4} accessibilityLevel={2} as="p">
                    {subtitle}
                </Heading>
                <Paragraph>{description}</Paragraph>
            </Stack>
        </Stack>
    );
}
